import type { Event as BugsnagEvent } from "@bugsnag/js"

const resizeObserverWarning =
	/^ResizeObserver loop (?:limit exceeded|completed with undelivered notifications)\.?$/

export default function bugsnagOnError(event: Pick<BugsnagEvent, "errors" | "unhandled">): boolean {
	// Discard only the browser's automatic resize delivery warnings. Keep manual
	// reports and any event containing another error so real failures stay visible.
	const isResizeDeliveryWarning =
		event.unhandled &&
		event.errors.length > 0 &&
		event.errors.every(
			(error) => error.errorClass === "Error" && resizeObserverWarning.test(error.errorMessage),
		)

	// BugSnag v7 cancels delivery when onError returns false.
	return !isResizeDeliveryWarning
}
